import { Divider } from "antd";
import { DATE_FORMAT_MMDDYYYY_AT_HHMM_A, DateUtils } from "utils/dateutils";
import { ExtractSpecCardItem } from "../model";
import { useMemo } from "react";

function InProgressCard({
  inProgressData
}: {
  inProgressData: ExtractSpecCardItem;
}) {
  return (
    <div className="rounded border border-solid border-ciq-gray-300 bg-white text-xs">
      <div className="p-3 flex flex-col space-y-1 bg-ciq-gray-50 bg-opacity-80 rounded-t">
        <div className="text-black text-opacity-70">File Name</div>
        <div className="text-black text-opacity-80 font-bold">
          {inProgressData.file_name}
        </div>
      </div>
      <div className="flex flex-col space-y-2 text-black text-opacity-60 p-3">
        <div className="flex justify-between">
          <span>Uploaded By:</span>
          <span className="truncate">
            {inProgressData.created_by_email || "-"}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Uploaded On:</span>
          <span>
            {inProgressData.created_at
              ? DateUtils.format(
                  inProgressData.created_at,
                  DATE_FORMAT_MMDDYYYY_AT_HHMM_A
                )
              : ""}
          </span>
        </div>
      </div>
    </div>
  );
}

function InProgressPanel({
  data
}: {
  data?: Array<ExtractSpecCardItem> | null;
}) {
  const inProgressData = useMemo(
    () => data?.filter((item) => item.status === "IN_PROGRESS"),
    [data]
  );
  if (!inProgressData?.length) return null;

  return (
    <div>
      <Divider />
      <div className="flex flex-col space-y-0.5">
        <div className="font-semibold text-black text-opacity-90">
          In Progress
        </div>
        <div className="text-black text-opacity-40 text-xs">
          Extraction will run in the background. An email will be sent once
          completed.
        </div>
      </div>
      <div className="flex flex-col space-y-6 p-4">
        {inProgressData?.map((item) => (
          <InProgressCard key={item.specification_id} inProgressData={item} />
        ))}
      </div>
    </div>
  );
}

export default InProgressPanel;
